<template>
  <header class="birdstool-header">
    <div class="birdstool-header-main">
      
      <!-- Linia 1: logo -->
      <router-link to="/" class="birdstool-logo">birdstool</router-link>
      
      <!-- Linia 2: PLN/PL po lewej, koszyk po prawej -->
      <div class="header-controls">
        <div class="lang-currency">
          <select class="header-select" v-model="currentCurrency" @change="changeCurrency">
            <option value="PLN">PLN</option>
            <option value="EUR">EUR</option>
            <option value="USD">USD</option>
            <option value="CZK">CZK</option> <!-- korona czeska -->
            <option value="HUF">HUF</option> <!-- forint węgierski -->
            <!--<option value="BGN">BGN</option> -->
            <option value="RON">RON</option> <!-- lej rumuński -->
            <option value="SEK">SEK</option> 
            <option value="DKK">DKK</option> 
          </select>
          <select class="header-select" v-model="currentLang" @change="changeLanguage">
            <option value="pl">PL</option>
            <option value="en">EN</option>
            <option value="de">DE</option>
            <option value="cs">CZ</option>
            <option value="ro">RO</option>
            <option value="lt">LT</option>
            <option value="hr">HR</option>
            <option value="bg">BG</option>
            <option value="hu">HU</option>
            <option value="it">IT</option>
            <option value="et">EE</option>
            <option value="da">DK</option>
            <option value="sk">SK</option>
            <option value="sl">SL</option>
            <option value="sv">SE</option>
            <option value="fr">FR</option>
            <option value="es">ES</option>
            <option value="nl">NL</option>
            <option value="el">GR</option>
            <option value="lv">LV</option>
            <option value="fi">FI</option>
            <option value="no">NO</option>
          </select>
        </div>

        <router-link to="/cart" class="birdstool-cart-btn" aria-label="Koszyk">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="9" cy="21" r="1"></circle>
            <circle cx="20" cy="21" r="1"></circle>
            <path d="M1.5 3.5h3l2.7 10.5a2 2 0 0 0 2 1.5h7.8a2 2 0 0 0 2-1.6l1.7-7.7H5.5"></path>
          </svg>
          <span v-if="cartCount" class="cart-count">{{ cartCount }}</span>
        </router-link>
      </div>

    </div>

    <!-- ewentualny dodatkowy element -->
    <div class="header-extra">
      <p>{{ translations.header?.title }}</p>
    </div>
  </header>
</template>


<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import eventBus from "@/eventBus"
import { currentLang, setLang, translations } from '@/locales/lang.js'
import { currentCurrency, setCurrency } from '@/composables/currency.js'

// --- AUTOMATYCZNE WYKRYWANIE JĘZYKA I WALUTY ---
const detectLocationSettings = async () => {
  try {
    const response = await fetch("https://ipapi.co/json/")
    const data = await response.json()

    if (data && data.country_code) {
      const country = data.country_code

      const countryToLang = {
                    DE: 'de',
                    AT: 'de',
                    PL: 'pl',
                    CZ: 'cs',
                    SK: 'sk',
                    SI: 'sl',
                    HR: 'hr',
                    HU: 'hu',
                    RO: 'ro',
                    BG: 'bg',
                    IT: 'it',
                    ES: 'es',
                    GR: 'el',
                    FR: 'fr',
                    BE: 'nl',
                    LU: 'fr',
                    NL: 'nl',
                    LV: 'lv',
                    LT: 'lt',
                    EE: 'et',
                    DK: 'da',
                    SE: 'sv', // jeśli masz szwedzki
                    GB: "en",
                    US: "en",
                    NO: 'no',
        };

      // USTAWIENIE JĘZYKA
    if (countryToLang[country]) {
      const lang = countryToLang[country];
      setLang(lang);
      currentLang.value = lang;
      localStorage.setItem('selectedLang', lang);
    } 
    else {
        setLang("en")
        currentLang.value = "en"
        localStorage.setItem('selectedLang', 'en')
      }

// --- USTAWIENIE WALUTY ---
if (country === "PL") {
  setCurrency("PLN")
  currentCurrency.value = "PLN"
  localStorage.setItem("selectedCurrency", "PLN")

} else if (country === "CZ") {
  setCurrency("CZK")
  currentCurrency.value = "CZK"
  localStorage.setItem("selectedCurrency", "CZK")

} else if (country === "HU") {
  setCurrency("HUF")
  currentCurrency.value = "HUF"
  localStorage.setItem("selectedCurrency", "HUF")

} else if (country === "RO") {
  setCurrency("RON")
  currentCurrency.value = "RON"
  localStorage.setItem("selectedCurrency", "RON")

} else if (country === "DK") {
  setCurrency("DKK")
  currentCurrency.value = "DKK"
  localStorage.setItem("selectedCurrency", "DKK")

} else if (country === "SE") {
  setCurrency("SEK")
  currentCurrency.value = "SEK"
  localStorage.setItem("selectedCurrency", "SEK")

} else if (["DE","AT","FR","ES","IT","NL","BE","LU","IE","PT","FI","GR","LT","LV","EE","SK","SI","HR","CY","MT","BG"].includes(country)) {
  setCurrency("EUR")
  currentCurrency.value = "EUR"
  localStorage.setItem("selectedCurrency", "EUR")

} else {
  // fallback: EUR
  setCurrency("EUR")
  currentCurrency.value = "EUR"
  localStorage.setItem("selectedCurrency", "EUR")
}
    }
  } catch (err) {
    console.warn("Nie udało się pobrać kraju użytkownika:", err)
  }
}

// Zmiana języka
const changeLanguage = () => {
  setLang(currentLang.value)
  localStorage.setItem('selectedLang', currentLang.value)
}

// Zmiana waluty
const changeCurrency = () => {
  setCurrency(currentCurrency.value)
  localStorage.setItem('selectedCurrency', currentCurrency.value)
}

// Licznik produktów w koszyku
const cartCount = ref(0)
const updateCartCount = () => {
  const cart = JSON.parse(localStorage.getItem("cart") || "[]")
  cartCount.value = cart.reduce((sum, item) => sum + (item.quantity || 0), 0)
}

onMounted(() => {
  // 1. Najpierw odczytaj z localStorage (jeśli jest)
  const savedLang = localStorage.getItem('selectedLang')
  const savedCurrency = localStorage.getItem('selectedCurrency')

  if (savedLang) {
    setLang(savedLang)
    currentLang.value = savedLang
  }
  if (savedCurrency) {
    setCurrency(savedCurrency)
    currentCurrency.value = savedCurrency
  }

  // 2. Jeśli nie ma w localStorage, wykryj automatycznie
  if (!savedLang || !savedCurrency) {
    detectLocationSettings()
  }

  updateCartCount()
  eventBus.on("cartUpdated", updateCartCount)
  window.addEventListener("storage", updateCartCount)
})

onBeforeUnmount(() => {
  eventBus.off("cartUpdated", updateCartCount)
  window.removeEventListener("storage", updateCartCount)
})
</script>
